//Internal imports
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { faqs } from "../data/faq.data";

export default function Faq() {
  return (
    <div className="flex flex-col gap-12 md:p-8">
      <h2 className="text-2xl md:text-3xl font-medium text-center">
        Frequently Asked Questions
      </h2>
      <Accordion type="single" collapsible className="w-full max-w-5xl mx-auto">
        {faqs.map((faq, index) => (
          <AccordionItem key={index} value={`item-${index}`}>
            <AccordionTrigger>
              <p className="md:text-xl text-start">{faq.question}</p>
            </AccordionTrigger>
            <AccordionContent>
              <div className="flex flex-col gap-3">
                {faq.answer.split("\n\n").map((paragraph, i) => (
                  <p key={i} className="md:text-lg text-start">
                    {paragraph}
                  </p>
                ))}
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
